<template>
	<div class="grid-toolbar">
		<span class="view-title">{{ reportName }}</span>
		<quick-filter
			v-if="hasFilters"
			:Columns="visibleColumns"
			:filter="quickFilter"
			@filterChanged="onQuickFilterChanged"
		/>
		<v-badge
			v-if="hasFilters"
			:value="advancedFiltersCount > 0"
			left
			class="d-none d-lg-flex"
			bordered
			overlap
		>
			<template v-slot:badge>
				<span style="color: white">{{ advancedFiltersCount }}</span>
			</template>
			<v-btn color="primary" @click="onShowAdvancedFilter">
				<v-icon class="mr-1">mdi-magnify</v-icon>
				Advanced search
			</v-btn>
		</v-badge>

		<filters-dialog
			v-if="showAdvancedFilter && hasFilters"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="visibleColumns"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</div>
</template>

<script>
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog.vue';

export default {
	namme: 'WorkbookReportPreviewToolbar',
	components: { QuickFilter, FiltersDialog },
	props: {
		reportName: String,
		quickFilter: Object,
		advancedFilter: Object,
		visibleColumns: Array,
		advancedFiltersCount: Number,
		hasFilters: Boolean,
	},
	data() {
		return {
			showAdvancedFilter: false,
		};
	},
	methods: {
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
	},
};
</script>
